class DetailsDialog {
  private dialog: HTMLDialogElement;
  private buttons: NodeListOf<HTMLButtonElement>;
  private closeButton: HTMLButtonElement;
  constructor(
    buttons: NodeListOf<HTMLButtonElement>,
    dialog: HTMLDialogElement,
    buttonClose: HTMLButtonElement,
  ) {
    this.buttons = buttons;
    this.dialog = dialog;
    this.closeButton = buttonClose;

    this.buttons.forEach((button) => {
      button.addEventListener("click", () => {
        this.dialog.showModal();
        this.setNoScroll(true);
        this.dialog.classList.remove("is-closing");
        const targetId = button.dataset.target;
        if (!targetId) return;
        const targetDetails = document.getElementById(
          targetId,
        ) as HTMLDetailsElement | null;
        setTimeout(() => {
          if (targetDetails) {
            targetDetails.open = true;
            targetDetails.scrollIntoView({
              behavior: "smooth",
              block: "start",
              inline: "start",
            });
          }
        }, 500);
      });
    });

    this.closeButton.addEventListener("click", () => {
      this.fermer(dialog);
    });
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) {
        this.fermer(dialog);
      }
    });
    this.initA11y();
  }
  initA11y = () => {
    this.dialog
      .querySelectorAll<HTMLElement>("details summary")
      .forEach((summary) => {
        summary.setAttribute("role", "button");
        summary.setAttribute("aria-expanded", "false");

        const nextSibling = summary.nextElementSibling as HTMLElement | null;
        if (nextSibling?.getAttribute("id")) {
          summary.setAttribute("aria-controls", nextSibling.id);
        }

        summary.addEventListener("click", (event) => {
          const details = (event.currentTarget as HTMLElement)?.closest(
            "details",
          );
          summary.setAttribute(
            "aria-expanded",
            String(!details?.hasAttribute("open")),
          );
        });
      });
    this.dialog?.addEventListener("keyup", (event) => {
      if (event.key === "Escape") this.fermer(this.dialog);
    });
  };
  fermer = (dialog: HTMLDialogElement) => {
    this.dialog.classList.add("is-closing");
    this.dialog.querySelectorAll("details").forEach((detail) => {
      detail.open = false;
    });
    setTimeout(() => {
      dialog.close();
      this.setNoScroll(false);
    }, 300);
  };
  setNoScroll = (on: boolean) => {
    document.body.classList.toggle("--no-scroll", !!on);
  };
}
export { DetailsDialog };
